module.exports = __webpack_public_path__ + "f07a26d9bdfb89e368f278697e6d593f.svg";